var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.249 6.553c1.365 0 2.472-1.188 2.472-2.654s-1.107-2.655-2.472-2.655-2.472 1.189-2.472 2.656c0 1.466 1.107 2.654 2.472 2.654zm4.249 4.147v-.829c0-1.493-1.159-2.737-2.55-2.737h-.308c-.386.248-.85.331-1.39.331s-.927-.083-1.39-.331h-.31c-1.39 0-2.55 1.244-2.55 2.736v.83c0 .58.386.995.927.995h6.721c.464 0 .85-.415.85-.995zm5.253.415c1.365 0 2.472-1.188 2.472-2.654s-1.107-2.655-2.472-2.655-2.472 1.189-2.472 2.655 1.107 2.654 2.472 2.654zm1.699.581h-.308c-.387.249-.927.332-1.39.332-.464 0-.928-.083-1.392-.332h-.308c-1.391 0-2.55 1.244-2.55 2.737v.83c0 .58.386.995.927.995h6.721c.541 0 .927-.415.927-.995v-.83c-.077-1.493-1.159-2.737-2.626-2.737zm-6.798 4.645c-1.545 0-2.935-.498-4.171-1.493h1.081c.464 0 .773-.332.773-.83 0-.497-.31-.83-.773-.83h-2.858c-.464 0-.773.333-.773.83v3.152c0 .498.31.83.773.83s.772-.332.772-.83v-1.078a7.889 7.889 0 0 0 5.176 1.908c.464 0 .773-.332.773-.83 0-.497-.31-.829-.773-.829zm-1.082-14.682c2.01 0 3.554.58 4.868 1.742h-1.159c-.463 0-.773.332-.773.83 0 .497.31.829.773.829h2.936c.463 0 .772-.332.772-.83v-3.152c0-.497-.309-.83-.772-.83-.464 0-.773.333-.773.83v.996c-1.622-1.327-3.554-2.074-5.871-2.074-.464 0-.773.332-.773.83 0 .497.31.829.773.829z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchUser);
export default __webpack_public_path__ + "static/media/switch_user.4949eea9e5e42c102c56047190ed9881.svg";
export { ForwardRef as ReactComponent };